import React from "react";
import ImageTile from "./ImageTile";
import LinkTile from "./LinkTile";
const Outlet = () => {
  return <div className="bg-gray-50 rounded" data-testid="ways-to-save-outlet" data-sentry-component="Outlet" data-sentry-source-file="Outlet.tsx">
      <ImageTile altText="Scratch and Dent" link="/outlet.html" logo="/uploads/design/2022/1/Homepage/scratch-and-dent_logo@2x.png" imageBackground="/uploads/design/2022/1/Homepage/scratch-and-dent_bg@2x.png" data-sentry-element="ImageTile" data-sentry-source-file="Outlet.tsx" />
      <LinkTile link="/outlet.html" linkText="Shop Outlet" description="Shop like-new items for less" data-sentry-element="LinkTile" data-sentry-source-file="Outlet.tsx" />
    </div>;
};
export default Outlet;